import * as React from "react";
import { forwardRef } from "react";
const SvgDoneSmall = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Property 1=Done, Size=S" }, /* @__PURE__ */ React.createElement("circle", { id: "Ellipse 381", cx: 6, cy: 6, r: 5, fill: "#1561D1", stroke: "#020617", strokeWidth: 2 })));
const ForwardRef = forwardRef(SvgDoneSmall);
export { ForwardRef as ReactComponent };
